import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';


export const CreateTagValidation = (daysForSchedule) => {
    const dailyChargingScheduleValidations = daysForSchedule.reduce((acc, day) => {
        acc[day] = yup.object().shape({
            pluginTime: yup.string().required(ERRORS.required),
            plugoutTime: yup.string().required(ERRORS.required),
        });
        return acc;
    }, {});
        
    return yup.object().shape({
        name: yup.string().required(ERRORS.required),
        tagID: yup.string().required(ERRORS.required),
        status: yup.bool().required(ERRORS.required),
        groupId: yup.string().optional(),
        chargingType: yup.string().required(ERRORS.required),
        vehicleBatteryCap: yup.number().min(0).required(ERRORS.required),
        vehicleChargingCap: yup.number().min(0).required(ERRORS.required),
        dailyChargingSchedule: yup.object().shape(dailyChargingScheduleValidations),
    });

}
    
export const CreateGroupValidation = yup.object().shape({
    name: yup.string().required(ERRORS.required),
    action: yup.bool().required(ERRORS.required),
});
